import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import WorkPage from "./pages/WorkPage/WorkPage";

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route exact path="/work" component={WorkPage} />
        <Route exact path="/" component={HomePage} />
      </Switch>
    </Router>
  );
}
